import { normalizeCustomDomainInput } from '@/lib/campaign-custom-domain'

export type CampaignViewPageInput = {
  slug?: string | null
  publicPageUrl?: string | null
  customDomain?: string | null
}

function resolveHttpsPageUrl(value: string | null | undefined): string | null {
  const trimmed = value?.trim() ?? ''
  if (trimmed === '') {
    return null
  }

  try {
    const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)
      ? trimmed
      : trimmed.startsWith('//')
        ? `https:${trimmed}`
        : `https://${trimmed}`
    const url = new URL(withScheme)
    if (url.protocol === 'http:') {
      url.protocol = 'https:'
    }
    if (url.protocol !== 'https:') {
      return null
    }

    return url.toString()
  } catch {
    return null
  }
}

/**
 * Destino da página pública da campanha, na ordem:
 * 1. URL externa (`public_page_url`)
 * 2. domínio personalizado
 * 3. landing padrão `/campanha/{slug}` (template default ou personalizado)
 */
export function resolveCampaignViewPageUrl(input: CampaignViewPageInput): string | null {
  const publicPageUrl = resolveHttpsPageUrl(input.publicPageUrl)
  if (publicPageUrl) {
    return publicPageUrl
  }

  const slug = input.slug?.trim() ?? ''
  const customDomain = input.customDomain
    ? normalizeCustomDomainInput(input.customDomain)
    : null

  if (customDomain) {
    if (slug !== '') {
      return `https://${customDomain}/campanha/${encodeURIComponent(slug)}`
    }

    return `https://${customDomain}/`
  }

  if (slug !== '') {
    return `/campanha/${encodeURIComponent(slug)}`
  }

  return null
}

export function resolveCampaignHomeHref(
  slug: string | null | undefined,
  customDomain: string | null | undefined,
  affiliateCode?: string | null
): string {
  const destination = resolveCampaignViewPageUrl({ slug, customDomain }) ?? '/'
  const affiliate = affiliateCode?.trim()
  if (!affiliate) return destination

  const separator = destination.includes('?') ? '&' : '?'
  return `${destination}${separator}${new URLSearchParams({ af: affiliate }).toString()}`
}
